/**
 * Today for one group, in words (user, 23/10/2026: "Hide the animations"):
 * how many drops, the lists in their order (#1 · the best), and what the
 * choice does to them — the played grid and its Failure example are gone.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { ListMode } from '../list-choice/list-mode';
import { type MatrixDrop, matrixSummary } from '../list-choice/matrix-model';

interface Props {
  mode: ListMode;
  drops: MatrixDrop[];
  lists: number;
  names: string[];
}

export const TodayLine: FC<Props> = ({ mode, drops, lists, names }) => {
  const ranked = drops.filter((d) => d.rank !== undefined).length;
  const shown = names.slice(0, Math.max(0, lists));
  return (
    <div className="flex flex-col gap-1 rounded-md border border-border/60 bg-muted/15 px-2.5 py-2" data-testid="today-line">
      <span className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
        Today · {drops.length} drop{drops.length === 1 ? '' : 's'}
      </span>
      {shown.length > 0 ? (
        <span className="flex flex-wrap gap-x-3 gap-y-0.5 font-mono text-[10.5px] text-muted-foreground">
          {shown.map((name, i) => (
            <span key={`${i}:${name}`}>
              #{i + 1} · {name}
            </span>
          ))}
        </span>
      ) : null}
      <p className="text-[10.5px] leading-snug text-foreground/80">{matrixSummary(mode, drops.length, lists, ranked)}</p>
    </div>
  );
};
